<template>
  <Layout v-loading="isLoading">
    <template #top>
      <el-date-picker
        size="medium"
        v-model="selectTime"
        type="date"
        placeholder="选择日期"
        :editable="false"
        :picker-options="{
          disabledDate(time) {
            return time.getTime() >= getDay(getLATime(), 1);
          },
        }"
        value-format="timestamp"
      >
      </el-date-picker>
      <el-button
        size="medium"
        type="primary"
        @click="search"
        style="margin: 0 10px"
        >查询</el-button
      >
      <span>
        {{ `当日收入:${totalToday.toFixed(2)}` }}
      </span>
      <el-divider direction="vertical"></el-divider>
      <span>
        {{ `前一日收入:${yesterdayToday.toFixed(2)}` }}
      </span>
    </template>
    <template>
      <el-table
        ref="comparisonTable"
        :data="tableData"
        style="width: 100%"
        border
        tooltip-effect="dark"
        :header-cell-style="{ background: '#f4f5f9', color: '#000' }"
      >
        <!-- 游戏名称 -->
        <el-table-column label="游戏名称" width="180">
          <template slot-scope="scope">
            <router-link
              :to="`/home/realization/income?appId=${scope.row.appId}`"
            >
              {{ scope.row.appName }}</router-link
            >
          </template>
        </el-table-column>
        <!-- 更新日期 -->
        <el-table-column label="更新日期" width="180">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{
              formatTime(
                new Date(scope.row.today.createTime),
                "yyyy-MM-dd HH:mm:00",
              )
            }}</span>
          </template>
        </el-table-column>
        <!-- 预估收入 -->
        <el-table-column label="预估收入" min-width="180">
          <template slot="header" slot-scope="scope">
            <span
              >预估收入
              <a @click="sortData(rawData, 'today', 'money')">今</a>/<a
                @click="sortData(rawData, 'yesterday', 'money')"
                >昨</a
              ></span
            >
          </template>
          <template slot-scope="scope">
            <el-tag effect="dark" size="small">{{
              formatData(scope.row.today.money ?? 0)
            }}</el-tag>
            <el-divider direction="vertical"></el-divider>
            <el-tag effect="dark" type="success" size="small">{{
              formatData(scope.row.yesterday.money ?? 0)
            }}</el-tag>
          </template>
        </el-table-column>
        <!-- eCPM -->
        <el-table-column label="eCPM" min-width="160">
          <template slot="header" slot-scope="scope">
            <span
              >eCPM <a @click="sortData(rawData, 'today', 'ecpm')">今</a>/<a
                @click="sortData(rawData, 'yesterday', 'ecpm')"
                >昨</a
              ></span
            >
          </template>
          <template slot-scope="scope">
            <el-tag
              effect="dark"
              size="small"
              :type="
                formatData(scope.row.today.ecpm ?? 0) > 100 ? 'danger' : ''
              "
              >{{ formatData(scope.row.today.ecpm ?? 0) }}</el-tag
            >
            <el-divider direction="vertical"></el-divider>
            <el-tag effect="dark" type="success" size="small">{{
              formatData(scope.row.yesterday.ecpm ?? 0)
            }}</el-tag>
          </template>
        </el-table-column>
        <!-- 点击率 -->
        <el-table-column label="点击率" min-width="160">
          <template slot="header" slot-scope="scope">
            <span
              >点击率
              <a @click="sortData(rawData, 'today', 'dianyuelv')">今</a>/<a
                @click="sortData(rawData, 'yesterday', 'dianyuelv')"
                >昨</a
              ></span
            >
          </template>
          <template slot-scope="scope">
            <el-tag
              effect="dark"
              size="small"
              :type="
                formatData(scope.row.today.dianyuelv ?? 0) > 0.5 ? 'danger' : ''
              "
              >{{ formatData(scope.row.today.dianyuelv ?? 0) }}</el-tag
            >
            <el-divider direction="vertical"></el-divider>
            <el-tag effect="dark" type="success" size="small">{{
              formatData(scope.row.yesterday.dianyuelv ?? 0)
            }}</el-tag>
          </template>
        </el-table-column>
        <!-- 广告请求时次数 -->
        <el-table-column label="广告请求时次数" min-width="160">
          <template slot="header" slot-scope="scope">
            <span
              >广告请求时次数
              <a @click="sortData(rawData, 'today', 'yaoqiu')">今</a>/<a
                @click="sortData(rawData, 'yesterday', 'yaoqiu')"
                >昨</a
              ></span
            >
          </template>
          <template slot-scope="scope">
            <el-tag effect="dark" size="small">{{
              scope.row.today.yaoqiu ?? 0
            }}</el-tag>
            <el-divider direction="vertical"></el-divider>
            <el-tag effect="dark" type="success" size="small">{{
              scope.row.yesterday.yaoqiu
            }}</el-tag>
          </template>
        </el-table-column>
        <!-- 展示次数 -->
        <el-table-column label="展示次数" min-width="160">
          <template slot="header" slot-scope="scope">
            <span
              >展示次数
              <a @click="sortData(rawData, 'today', 'baoguang')">今</a>/<a
                @click="sortData(rawData, 'yesterday', 'baoguang')"
                >昨</a
              ></span
            >
          </template>
          <template slot-scope="scope">
            <el-tag effect="dark" size="small">{{
              scope.row.today.baoguang ?? 0
            }}</el-tag>
            <el-divider direction="vertical"></el-divider>
            <el-tag effect="dark" type="success" size="small">{{
              scope.row.yesterday.baoguang ?? 0
            }}</el-tag>
          </template>
        </el-table-column>
        <!-- 展示率 -->
        <el-table-column label="展示率" min-width="160">
          <template slot="header" slot-scope="scope">
            <span
              >展示率
              <a @click="sortData(rawData, 'today', 'dabiaolv')">今</a>/<a
                @click="sortData(rawData, 'yesterday', 'dabiaolv')"
                >昨</a
              ></span
            >
          </template>
          <template slot-scope="scope">
            <el-tag effect="dark" size="small">{{
              formatData(scope.row.today.dabiaolv ?? 0)
            }}</el-tag>
            <el-divider direction="vertical"></el-divider>
            <el-tag effect="dark" type="success" size="small">{{
              formatData(scope.row.yesterday.dabiaolv ?? 0)
            }}</el-tag>
          </template>
        </el-table-column>
        <!-- IP数 -->
        <el-table-column label="IP数" min-width="160">
          <template slot="header" slot-scope="scope">
            <span
              >IP数 <a @click="sortData(rawData, null, 'todayIpNum')">今</a>/<a
                @click="sortData(rawData, null, 'yesterdayIpNum')"
                >昨</a
              ></span
            >
          </template>
          <template slot-scope="scope">
            <el-tag effect="dark" size="small">{{
              scope.row.todayIpNum ?? 0
            }}</el-tag>
            <el-divider direction="vertical"></el-divider>
            <el-tag effect="dark" type="success" size="small">{{
              scope.row.yesterdayIpNum ?? 0
            }}</el-tag>
          </template>
        </el-table-column>
        <!-- 人均广告数 -->
        <el-table-column label="人均广告数" min-width="160">
          <template slot="header" slot-scope="scope">
            <span
              >人均广告数
              <a @click="sortData(rawData, null, 'todayAvgAdvert')">今</a>/<a
                @click="sortData(rawData, null, 'yesterdayAvgAdvert')"
                >昨</a
              ></span
            >
          </template>
          <template slot-scope="scope">
            <el-tag effect="dark" size="small">{{
              formatData(scope.row.todayAvgAdvert ?? 0)
            }}</el-tag>
            <el-divider direction="vertical"></el-divider>
            <el-tag effect="dark" type="success" size="small">{{
              formatData(scope.row.yesterdayAvgAdvert ?? 0)
            }}</el-tag>
          </template>
        </el-table-column>
        <!-- 点击量 -->
        <el-table-column label="点击量" min-width="160">
          <template slot="header" slot-scope="scope">
            <span
              >点击量 <a @click="sortData(rawData, 'today', 'dianji')">今</a>/<a
                @click="sortData(rawData, 'yesterday', 'dianji')"
                >昨</a
              ></span
            >
          </template>
          <template slot-scope="scope">
            <el-tag effect="dark" size="small">{{
              scope.row.today.dianji ?? 0
            }}</el-tag>
            <el-divider direction="vertical"></el-divider>
            <el-tag effect="dark" type="success" size="small">{{
              scope.row.yesterday.dianji ?? 0
            }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template #bottom> </template>
  </Layout>
</template>

<script>
import Layout from "@/components/Layout";
import { getBusinessIncomeTotal } from "@/api/getBusinessIncomeTotal.js";
import { formatTime } from "@/utils/time.js";
import { getLATime, getDay } from "@/utils/time.js";

export default {
  components: {
    Layout,
  },
  data() {
    return {
      selectTime: "",
      rawData: [],
      formatTime,
      tableData: [],
      isLoading: false,
      getLATime: getLATime,
      getDay: getDay,
    };
  },
  methods: {
    async requestData(params) {
      this.isLoading = true;
      try {
        const res = await getBusinessIncomeTotal(params);
        this.isLoading = false;
        this.rawData = res;
        this.sortData(res, "today", "money");
        console.log(res);
      } catch (error) {
        this.isLoading = false;
      }
    },
    formatData(num) {
      return num ? parseFloat(num).toFixed(2) : num;
    },
    sortData(list, day, type) {
      this.tableData = list.sort((a, b) => {
        if (day) {
          return parseFloat(b[day][type] ?? 0) - parseFloat(a[day][type] ?? 0);
        } else {
          return parseFloat(b[type] ?? 0) - parseFloat(a[type] ?? 0);
        }
      });
    },
    search() {
      console.log(this.selectTime);
      if (this.selectTime) {
        this.requestData({ queryDate: this.selectTime });
      } else {
        this.$message({
          showClose: true,
          message: "请选择日期",
          type: "error",
        });
      }
    },
  },
  mounted() {
    this.requestData();
  },
  computed: {
    totalToday() {
      return this.rawData.reduce((previousValue, currentValue) => {
        return parseFloat(currentValue.today.money ?? 0) + previousValue;
      }, 0);
    },
    yesterdayToday() {
      return this.rawData.reduce((previousValue, currentValue) => {
        console.log(currentValue.yesterday.money);
        return parseFloat(currentValue.yesterday.money ?? 0) + previousValue;
      }, 0);
    },
  },
};
</script>

<style lang="less" scoped>
.top {
  span {
    font-size: 24px;
  }
  .el-divider--vertical {
    vertical-align: unset;
  }
}

.el-table .cell {
  a {
    color: #409eff;
  }
}

.el-divider--vertical {
  margin: 0 4px;
}
</style>
